const state = {
  dataObj: {},
  driverInfoCount: 0,
  vehicleCount: 0,
  waybillCount: 0,
  clientContractCount: 0,
  orderCount: 0,
  waybillScrollList: [],
  locationVehicle: [],
  waybillList: [],
  waybillMonthList: [],
  orderList: [],
  orderMonthList: [],
  waybillDayList: [],
}

const actions = {}
const mutations = {
  SET_DATA_OBJ (state, dataObj) {
    state.dataObj = dataObj
  },
  SET_DATA_OBJ_DRIVER_COUNT (state, count) {
    state.driverInfoCount = count
  },
  SET_DATA_OBJ_VEHICLE_COUNT (state, count) {
    state.vehicleCount = count
  },
  SET_DATA_OBJ_WAYBILL_COUNT (state, count) {
    state.waybillCount = count
  },

  SET_DATA_OBJ_CLIENT_CONTRACT_COUNT (state, count) {
    state.clientContractCount = count
  },
  SET_DATA_OBJ_ORDER_COUNT (state, count) {
    state.orderCount = count
  },
  SET_DATA_OBJ_WAYBILL_SCROLL_LIST (state, list) {
    state.waybillScrollList = list
  },
  SET_DATA_OBJ_LOCATION_VEHICLE (state, list) {
    state.locationVehicle = list
  },
  SET_DATA_OBJ_WAYBILL_LIST (state, list) {
    state.waybillList = list
  },
  SET_DATA_OBJ_WAYBILL_MONTH_LIST (state, list) {
    state.waybillMonthList = list
  },
  SET_DATA_OBJ_ORDER_LIST (state, list) {
    state.orderList = list
  },
  SET_DATA_OBJ_ORDER_MONTH_LIST (state, list) {
    state.orderMonthList = list
  },
  SET_DATA_OBJ_WAYBILL_DAY_LIST (state, list) {
    state.waybillDayList = list
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
